import {
    AppBar,
    Box,
    Toolbar,
    Typography,
    useTheme,
    Container,
} from "@mui/material";
import { useLocation } from "react-router-dom";

// define slugs → titles once
const PAGE_TITLES: Record<string, string> = {
    "survey-form": "Survey for Muslim Minority Women",
    "bhajani-mandal": "Bhajani Mandal Registration / भजन मंडळ नोंदणी",
    "register-jatra": "Jatra Survey / जत्रा सर्वेक्षण",

    // add more mappings here if needed
};

export default function RegisterTopbar() {
    const theme = useTheme();
    const location = useLocation();

    // last part of path e.g. "/guest/survey-form" → "survey-form"
    const slug = location.pathname.split("/").filter(Boolean).pop() ?? "";
    const pageTitle = PAGE_TITLES[slug] || "Chief Minister's Community Health Camp";

    return (
        <Box sx={{ zIndex: 101 }}>
            <AppBar elevation={5} position="static" sx={{ backgroundColor: "common.white" }}>
                <Container maxWidth={slug === "register-jatra" ? "lg" : "xl"} disableGutters>
                    <Toolbar
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            minHeight: "59px !important",
                            px: 2,
                        }}
                    >
                        {/* Left side */}
                        <Box display="flex" alignItems="center" sx={{ flexGrow: 1, cursor: "pointer" }}>
                            <Box>
                                <img
                                    src="/images/logo/camp-logo.jpg"
                                    alt="Government Logo"
                                    style={{ width: slug === "bhajani-mandal" ? "100%" : 48, height: slug === "bhajani-mandal" ? 80: 50 }}
                                />
                            </Box>

                            <Box
                                sx={{
                                    borderRight: { xs: "none", md: `2px solid ${theme.palette.primary.main}` },
                                    height: "45px",
                                    mx: 2,
                                }}
                            />

                            <Box sx={{ maxWidth: "700px", flexShrink: 1, p: { xs: 1, md: 1 } }}>
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    color={theme.palette.primary.main}
                                    sx={{ fontSize: { xs: "1rem", md: "1.3rem" } }}
                                >
                                    {pageTitle}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Right side */}
                        <Box display="flex" alignItems="center">
                            <img
                                src="/images/guest/guest_Topbar-logo.png"
                                alt="Guest Logo"
                                style={{ width: 60, height: 60 }}
                            />
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </Box>
    );
}
